<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center"> 
                                <div class="edit">
                                    <button title="back page" (click)="backToOnboarding()">
                                    <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Onboarding User</h3>
                            </div>
                        </div>
                    </div> 
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex">
                            <h3><a (click)="openHrmonboarding()" class="active cursor-pointer">HR</a></h3>
                            <h3><a (click)="openndaonboarding()" class="cursor-pointer">NDA</a></h3>
                            <h3><a (click)="openItonboarding()" class="cursor-pointer">IT</a></h3>
                        </div>
                      </div>
                    <div class="canvas-data">
                        <form [formGroup]="usersForm">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Personal Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="firstName"/>
                                            <label class="floating-label-special">Employee First Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="middleName"/>
                                            <label class="floating-label-special">Employee Middle Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="lastName"/>
                                            <label class="floating-label-special">Employee Last Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="displayName"/>
                                            <label class="floating-label-special" for="displayName">Display Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="alternateEmailId"/>
                                            <label class="floating-label-special">Personal Email</label>
                                            <i class="ri-mail-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="phoneNo"/>
                                            <label class="floating-label-special">Contact Number</label>
                                            <i class="ri-smartphone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input formControlName="birthDate" type="date"  />
                                            <label for="birthDate" class="floating-label-special">Birth Date*</label>
                                            <i class="ri-file-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Company Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="localId"/>
                                            <label class="floating-label-special">Employee Id*</label>
                                            <i class="ri-code-box-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">                                     
                                        <div class="input-item">
                                            <input type="text" formControlName="userId"/>
                                            <label class="floating-label-special">User Id</label>
                                            <i class="ri-code-box-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-4">
                                    <div class="input">
                                      <div class="input-item">
                                        <input type="text" formControlName="password" disabled/>
                                        <label class="floating-label-special">Pragamana Password</label>
                                        <i class="ri-user-line"></i>
                                      </div>
                                    </div>
                                </div> -->
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="currentDesignation"/>
                                            <label class="floating-label-special">Designation</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">                                     
                                        <div class="input-item">
                                            <input type="text" formControlName="department"/>
                                            <label class="floating-label-special">Department</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="date" formControlName="joinDate"/>
                                            <label class="floating-label-special">Joining Date</label>
                                            <i class="ri-calendar-2-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Other Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="status" disabled>
                                                <option value="" disabled selected>Select Status</option>
                                                <option value="withHrTeam">With Hr Team</option>
                                                <option value="withNDATeam">With NDA Team</option>
                                                <option value="withItTeam">With IT Team</option>
                                                <option value="waitingForApproval">Waiting For Approval</option>
                                                <option value="approved">Approved</option>
                                            </select>
                                            <label class="floating-label-special">Status</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="location"/>
                                            <label class="floating-label-special">Location</label>
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input list="taskOwnerDatalist" formControlName="supervisonName"/>
                                            <!-- <datalist id="taskOwnerDatalist">
                                                <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                            </datalist> -->
                                            <label class="floating-label-special">Supervisor</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input list="taskOwnerDatalist" formControlName="managerName"/>
                                            <!-- <datalist id="taskOwnerDatalist">
                                                <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                            </datalist> -->
                                            <label class="floating-label-special">Manager Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="emailIdRequired" disabled>
                                                <option value="" disabled selected>Email ID Required</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">Email ID Required</label>
                                              <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="permanentOrContractor" disabled>
                                                <option value="" disabled selected>Employment Contract</option>
                                                <option value="Permanent">Permanent</option>
                                                <option value="Contractor">Contractor</option>
                                              </select>
                                              <label class="floating-label-special">Employment Contract</label>
                                            <i class="ri-phone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="systemRequiredBoolean" disabled>
                                                <option value="" disabled selected>System Required</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">System Required</label>
                                            <i class="ri-phone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="systemRequired" disabled>
                                                <option value="" disabled selected>Select System Type</option>
                                                <option value="Workstation">Workstation</option>
                                                <option value="Laptop">Laptop</option>
                                            </select>
                                            <label class="floating-label-special">System Type*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </section>
    </article> 
</main>